import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../../../../environments/environment';
import { ServiceBase } from '../../../../shared/service-base/ServiceBase';

@Injectable()
export class TipoAndamentoService extends ServiceBase {
  private baseUrlService: string;

  constructor(
    http: HttpClient,
    router: Router
  ) {
    super(http, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/cruzamento_tipo_andamento`;
  }

  public getTipoAndamentos(): Promise<any> {
    return this.get([]);
  }

  public adicionarTipoAndamento(nome: string): Promise<any> {
    const url = this.getURL();
    const body = {
      descAndamentoFab: nome
    };
    const options = (this as any).getOptions();

    return (this as any).http.post(url, body, options)
      .toPromise()
      .then((this as any).tratarRetorno);
  }

  public removerTipoAndamento(id: number): Promise<any> {
    const url = `${this.getURL()}?idTipoAndamento=${id}`;
    const options = (this as any).getOptions();

    return (this as any).http.delete(url, options)
      .toPromise()
      .then((this as any).tratarRetorno);
  }

  public atualizarTipoAndamento(id: number, nome: string): Promise<any> {
    const parametros = [
      { nome: 'idTipoAndamento', valor: id.toString() }
    ];
    const body = {
      descAndamentoFab: nome
    };
    return this.atualizar(body, parametros);
  }

  public getTipoAndamentoPorId(id: number): Promise<any> {
    const parametros = [
      { nome: 'idTipoAndamento', valor: id.toString() }
    ];
    return this.get(parametros);
  }

  public getVinculosTipoAndamento(idTipoAndamento: number): Promise<any> {
    const url = `${this.getURL()}/vinculos?idTipoAndamento=${idTipoAndamento}`;
    const options = (this as any).getOptions();

    return (this as any).http.get(url, options)
      .toPromise()
      .then((response: any) => {
        return (this as any).tratarRetorno(response);
      })
      .catch((error: any) => {
        console.error('Erro na requisição de vínculos:', error);
        throw error;
      });
  }

  public salvarVinculosTipoAndamento(idTipoAndamento: number, elementosVinculados: any[]): Promise<any> {
    const url = `${this.getURL()}/vincular?idTipoAndamento=${idTipoAndamento}`;
    const body = {
      descTipoAndamentos: elementosVinculados.map(elemento => ({
        descTipoAndamento: elemento.nome,
        contemFabrica: !!elemento.contemFabrica
      }))
    };
    const options = (this as any).getOptions();

    return (this as any).http.post(url, body, options)
      .toPromise()
      .then((response: any) => {
        return (this as any).tratarRetorno(response);
      })
      .catch((error: any) => {
        console.error('Erro ao salvar vínculos:', error);
        throw error;
      });
  }
}
